import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vShow as _vShow, resolveDirective as _resolveDirective, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../../assets/images/lock.svg'


const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "task-details"
}
const _hoisted_6 = { class: "container row m-0 p-1" }
const _hoisted_7 = { class: "form-group col-12 mt-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", {
  for: "task-name",
  class: "me-2"
}, "Client:", -1 /* HOISTED */)
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "mt-2 mb-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Current/Last Care Period:", -1 /* HOISTED */)
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", { class: "me-2" }, "Agency:", -1 /* HOISTED */)
const _hoisted_14 = { class: "col-auto form-group" }
const _hoisted_15 = { class: "input-group flex-nowrap" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Start Date ", -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_18 = { class: "input-group date datepickerInput" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_21 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "pt-4 w-5" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, " End Date ", -1 /* HOISTED */)
const _hoisted_24 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_25 = { class: "input-group date datepickerInput" }
const _hoisted_26 = ["value", "disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_28 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_30 = { class: "form-group col-10 col-md-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "shift-length" }, " Shift Length ", -1 /* HOISTED */)
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "col-auto form-group pb-2"
}
const _hoisted_35 = { class: "input-group flex-nowrap" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Start Time ", -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "w-5 pt-4" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " End Time ", -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_45 = { class: "form-group form-check custom-checkbox col-11 mt-2 ms-3 d-block d-md-flex" }
const _hoisted_46 = { class: "d-flex d-md-inline-block" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "schedule-without-time"
}, " Schedule Without Time ", -1 /* HOISTED */)
const _hoisted_48 = { class: "d-flex d-md-inline-block ms-md-5" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "override-shift-length"
}, " Override Shift Length ", -1 /* HOISTED */)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_52 = { class: "form-group col-6 col-md-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "Recurrence", -1 /* HOISTED */)
const _hoisted_56 = ["value"]
const _hoisted_57 = ["value"]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_59 = { class: "form-group col-6 col-md-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_62 = { class: "input-group date datepickerInput" }
const _hoisted_63 = ["value"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_65 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_66 = { class: "form-group col-6 col-md-3" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_70 = ["value"]
const _hoisted_71 = ["value"]
const _hoisted_72 = { class: "form-group col-6 col-md-3" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", {
  for: "days",
  class: "mb-2"
}, " Repeat On ", -1 /* HOISTED */)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_75 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_77 = { class: "form-group col-6 col-md-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_80 = { class: "input-group date datepickerInput" }
const _hoisted_81 = ["value"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_83 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_84 = { class: "form-group col-6 col-md-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_88 = ["value"]
const _hoisted_89 = ["value"]
const _hoisted_90 = { class: "form-group col-6 col-md-3" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", null, "Repeat Every ", -1 /* HOISTED */)
const _hoisted_94 = ["value"]
const _hoisted_95 = ["value"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_97 = { class: "form-group col-6 col-md-3" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_99 = { class: "form-group" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", null, "Repeat By ", -1 /* HOISTED */)
const _hoisted_101 = ["value"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: 1 }, "Day of Month", -1 /* HOISTED */)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: 2 }, "Day of Week", -1 /* HOISTED */)
const _hoisted_104 = [
  _hoisted_102,
  _hoisted_103
]
const _hoisted_105 = { class: "form-group col-6 col-md-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_108 = { class: "input-group date datepickerInput" }
const _hoisted_109 = ["value"]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_111 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_113 = { class: "form-group col-12" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Select Days ", -1 /* HOISTED */)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_116 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_119 = { class: "form-group col-6 col-md-3" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", { for: "date" }, " Repeat Until ", -1 /* HOISTED */)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_122 = { class: "input-group date datepickerInput" }
const _hoisted_123 = ["value"]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_125 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_127 = { class: "form-group col-10 col-md-5 col-lg-3" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { for: "payment-source" }, " Payment Source ", -1 /* HOISTED */)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: null }, "-- Select Payment Source --", -1 /* HOISTED */)
const _hoisted_131 = ["value"]
const _hoisted_132 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-100 mt-2" }, null, -1 /* HOISTED */)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = { class: "form-group col-10 col-md-5 col-lg-3" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { for: "task" }, " Task ", -1 /* HOISTED */)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_138 = {
  key: 0,
  class: "multi-select-filter"
}
const _hoisted_139 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_141 = {
  key: 6,
  class: "form-group col-6 col-md-3"
}
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", { for: "user-new" }, " Caregiver/Employee ", -1 /* HOISTED */)
const _hoisted_143 = { class: "fas fa-question-circle tooltip-blue" }
const _hoisted_144 = { for: "employee" }
const _hoisted_145 = { key: 1 }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("span", { class: "shimmer-loading w-100 mt-2" }, null, -1 /* HOISTED */)
const _hoisted_147 = [
  _hoisted_146
]
const _hoisted_148 = {
  key: 7,
  class: "col-6 col-md-12 col-lg-3 p-0 m-0 mt-4 mt-md-0 mt-lg-4 ms-lg-4"
}
const _hoisted_149 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_150 = /*#__PURE__*/_createElementVNode("button", { class: "button find-ai-button" }, "Find a Match", -1 /* HOISTED */)
const _hoisted_151 = [
  _hoisted_150
]
const _hoisted_152 = {
  key: 1,
  class: "form-group col-12"
}
const _hoisted_153 = { class: "find-ai-disabled-btn ai-disabled" }
const _hoisted_154 = /*#__PURE__*/_createTextVNode(" Find a Match ")
const _hoisted_155 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_156 = [
  _hoisted_154,
  _hoisted_155
]
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "me-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-solid fa-star icon-gold" }),
    /*#__PURE__*/_createTextVNode(" - Favorite Staff")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "me-2" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-star icon-gold" }),
    /*#__PURE__*/_createTextVNode(" - Oriented Staff")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-ban" }),
    /*#__PURE__*/_createTextVNode(" - Do Not Send Staff")
  ])
], -1 /* HOISTED */)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_160 = {
  key: 8,
  class: "form-group custom-control form-check col-10 mt-2 ms-3"
}
const _hoisted_161 = ["checked"]
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "billable"
}, " Post to AxxessCARE ", -1 /* HOISTED */)
const _hoisted_163 = {
  key: 9,
  class: "form-group col-10 col-md-6 col-lg-3 mt-2"
}
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", { for: "task-name" }, " Task Type: ", -1 /* HOISTED */)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Task Type", -1 /* HOISTED */)
const _hoisted_166 = ["value"]
const _hoisted_167 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_169 = { class: "col-10 col-md-6 form-group" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("label", { for: "comments" }, " Comment ", -1 /* HOISTED */)
const _hoisted_171 = {
  key: 2,
  class: "d-flex flex-wrap-reverse flex-md-nowrap justify-content-center my-2"
}
const _hoisted_172 = { key: 0 }
const _hoisted_173 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_174 = [
  _hoisted_173
]
const _hoisted_175 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_TimePicker = _resolveComponent("TimePicker")!
  const _component_DayPicker = _resolveComponent("DayPicker")!
  const _component_MultiDatePickerHC = _resolveComponent("MultiDatePickerHC")!
  const _component_GroupDropdownSelect = _resolveComponent("GroupDropdownSelect")!
  const _component_MultiSelectDropdown = _resolveComponent("MultiSelectDropdown")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_SaveNotifyUser = _resolveComponent("SaveNotifyUser")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: "Employee Scheduler",
    "application-id": _ctx.visitDetails.Application,
    "show-product-pill": true,
    "show-background": false
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.visitDetails.FirstName) + " " + _toDisplayString(_ctx.visitDetails.LastName), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_ctx.carePeriod), 1 /* TEXT */)
                ]),
                _createElementVNode("p", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", null, _toDisplayString(_ctx.visitDetails.AgencyName), 1 /* TEXT */)
                ])
              ]),
              _createCommentVNode(" Statement Range "),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "startDateTime",
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDateInput(_ctx.newVisitDetails.startDateTime.date),
                            class: _normalizeClass(`form-control rounded-left-5  ${
                                                !_ctx.v$.newVisitDetails.startDateTime.date.$error
                                                    ? ''
                                                    : 'field-invalid mt-0'
                                            }`),
                            onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.startDateTime.date.$touch && _ctx.v$.newVisitDetails.startDateTime.date.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_19),
                          _hoisted_20
                        ]),
                        (_ctx.v$.newVisitDetails.startDateTime.date.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Start Date is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ]),
                  _hoisted_22,
                  _createElementVNode("div", null, [
                    _hoisted_23,
                    (_ctx.overrideShiftLength)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "*"))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_DatePicker, {
                      id: "endDate",
                      getDate: _ctx.taskDateChanged
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "endDateTime",
                            class: _normalizeClass(["form-control rounded-left-5", `form-control rounded-left-5 ${
                                                !_ctx.v$.newVisitDetails.endDateTime.date.$error ? '' : 'field-invalid mt-0'
                                            }`]),
                            placeholder: "MM/DD/YYYY",
                            value: _ctx.formatDateInput(_ctx.newVisitDetails.endDateTime.date),
                            disabled: !_ctx.overrideShiftLength && !_ctx.scheduleWithoutTime,
                            "date-format-only": "",
                            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.endDateTime.date.$touch && _ctx.v$.newVisitDetails.endDateTime.date.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_26),
                          _hoisted_27
                        ]),
                        (_ctx.v$.newVisitDetails.endDateTime.date.$error)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, "End Date is required."))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ])
                ])
              ]),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.shiftLength) = $event)),
                  disabled: _ctx.scheduleWithoutTime || _ctx.overrideShiftLength
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (i) => {
                    return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i === 1 ? "Hour" : "Hours"), 9 /* TEXT, PROPS */, _hoisted_33)
                  }), 64 /* STABLE_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_32), [
                  [_vModelSelect, _ctx.shiftLength]
                ])
              ]),
              (!_ctx.scheduleWithoutTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", null, [
                          _hoisted_36,
                          _hoisted_37,
                          _createVNode(_component_TimePicker, { onUpdateProps: _ctx.changeStartTime }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                placeholder: "hh:mm AM",
                                type: "text",
                                autocomplete: "off",
                                maxlength: "8",
                                value: _ctx.newVisitDetails.startDateTime.time,
                                class: _normalizeClass(`form-control ${
                                                !_ctx.v$.newVisitDetails.startDateTime.time.$error
                                                    ? ''
                                                    : 'field-invalid mt-0'
                                            }`),
                                onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.startDateTime.time.$touch && _ctx.v$.newVisitDetails.startDateTime.time.$touch(...args)))
                              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_38)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onUpdateProps"]),
                          (_ctx.v$.newVisitDetails.startDateTime.time.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Start Time is required. "))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _hoisted_40,
                        _createElementVNode("div", null, [
                          _hoisted_41,
                          (_ctx.overrideShiftLength)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, "*"))
                            : _createCommentVNode("v-if", true),
                          _createVNode(_component_TimePicker, {
                            onUpdateProps: _ctx.changeEndTime,
                            id: "schedule-hc-task-end-time"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("input", {
                                placeholder: "hh:mm AM",
                                type: "text",
                                class: _normalizeClass(["form-control", `form-control ${
                                                !_ctx.v$.newVisitDetails.endDateTime.time.$error ? '' : 'field-invalid mt-0'
                                            }`]),
                                autocomplete: "off",
                                maxlength: "8",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newVisitDetails.endDateTime.time) = $event)),
                                disabled: !_ctx.overrideShiftLength,
                                onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.endDateTime.time.$touch && _ctx.v$.newVisitDetails.endDateTime.time.$touch(...args)))
                              }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_43), [
                                [_vModelText, _ctx.newVisitDetails.endDateTime.time]
                              ])
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onUpdateProps"]),
                          (_ctx.v$.newVisitDetails.endDateTime.time.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, " End Time is required. "))
                            : _createCommentVNode("v-if", true)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "schedule-without-time",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scheduleWithoutTime) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.scheduleWithoutTime]
                  ]),
                  _hoisted_47
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "override-shift-length",
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.overrideShiftLength) = $event)),
                    disabled: _ctx.scheduleWithoutTime
                  }, null, 8 /* PROPS */, _hoisted_49), [
                    [_vModelCheckbox, _ctx.overrideShiftLength]
                  ]),
                  _hoisted_50
                ])
              ]),
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("select", {
                    class: "form-select",
                    value: _ctx.newVisitDetails.recurrence.type,
                    onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleRecurrenceChange && _ctx.handleRecurrenceChange(...args))),
                    name: "recurrence"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.recurrenceType), ([key, value]) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: key,
                        value: value.value
                      }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_57))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_56)
                ])
              ]),
              _createCommentVNode(" Daily "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Daily)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_58,
                    _createElementVNode("div", _hoisted_59, [
                      _hoisted_60,
                      _hoisted_61,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("input", {
                              id: "date",
                              name: "endDate",
                              type: "text",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_63),
                            _hoisted_64
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "day" : "days"), 9 /* TEXT, PROPS */, _hoisted_71)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_70)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Weekly "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Weekly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _hoisted_74,
                      _createVNode(_component_DayPicker, {
                        "selected-days-string": _ctx.newVisitDetails.recurrence.daysOfWeek,
                        onUpdateSelectedDays: _ctx.updateDaysOfWeek
                      }, null, 8 /* PROPS */, ["selected-days-string", "onUpdateSelectedDays"]),
                      (_ctx.v$.newVisitDetails.recurrence.daysOfWeek.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_75, "Repeat on Date is required."))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_76,
                    _createElementVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _hoisted_79,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_80, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_81),
                            _hoisted_82
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_83, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "week" : "weeks"), 9 /* TEXT, PROPS */, _hoisted_89)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_88)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Monthly "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Monthly)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_90, [
                      _hoisted_91,
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatNumber,
                          name: "repeat-every"
                        }, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(31, (i) => {
                            return _createElementVNode("option", { value: i }, _toDisplayString(i) + " " + _toDisplayString(i == 1 ? "month" : "months"), 9 /* TEXT, PROPS */, _hoisted_95)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 8 /* PROPS */, _hoisted_94)
                      ])
                    ]),
                    _hoisted_96,
                    _createElementVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _createElementVNode("div", _hoisted_99, [
                        _hoisted_100,
                        _createElementVNode("select", {
                          class: "form-select",
                          value: _ctx.newVisitDetails.recurrence.repeatBy,
                          name: "repeat-every"
                        }, _hoisted_104, 8 /* PROPS */, _hoisted_101)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_105, [
                      _hoisted_106,
                      _hoisted_107,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_108, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_109),
                            _hoisted_110
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_111, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Flexible "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.Flexible)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _hoisted_112,
                    _createElementVNode("div", _hoisted_113, [
                      _hoisted_114,
                      _hoisted_115,
                      _createVNode(_component_MultiDatePickerHC, {
                        result: _ctx.visitDates,
                        onUpdateResult: _ctx.updateResult,
                        "current-care-details": _ctx.currentCareDetailList
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("input", {
                            class: _normalizeClass(`form-control ${
                                        !_ctx.v$.newVisitDetails.recurrence.flexibleDates.$error ? '' : 'field-invalid mt-0'
                                    }`),
                            onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.flexibleDates.$touch && _ctx.v$.newVisitDetails.recurrence.flexibleDates.$touch(...args)))
                          }, null, 34 /* CLASS, HYDRATE_EVENTS */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["result", "onUpdateResult", "current-care-details"]),
                      (_ctx.v$.newVisitDetails.recurrence.flexibleDates.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_116, "Dates are required."))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _hoisted_117
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" 60 days "),
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.SixtyDays)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _hoisted_121,
                      _createVNode(_component_DatePicker, { getDate: _ctx.taskDateChanged }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("input", {
                              id: "date",
                              type: "text",
                              name: "endDate",
                              placeholder: "Select Date",
                              "date-format-only": "",
                              value: _ctx.formatDateInput(_ctx.newVisitDetails.recurrence.endDate),
                              class: _normalizeClass(`form-control ${
                                            !_ctx.v$.newVisitDetails.recurrence.endDate.$error ? '' : 'field-invalid mt-0'
                                        }`),
                              onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.recurrence.endDate.$touch && _ctx.v$.newVisitDetails.recurrence.endDate.$touch(...args)))
                            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_123),
                            _hoisted_124
                          ]),
                          (_ctx.v$.newVisitDetails.recurrence.endDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_125, "Repeat Until Date is required."))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" End of recurrence "),
              _hoisted_126,
              _createElementVNode("div", _hoisted_127, [
                _hoisted_128,
                _hoisted_129,
                _withDirectives(_createElementVNode("select", {
                  id: "payment-source",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.newVisitDetails.payorId) = $event)),
                  class: _normalizeClass(`form-select ${!_ctx.v$.newVisitDetails.payorId.$error ? '' : 'field-invalid mt-0'}`),
                  onBlur: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.v$.newVisitDetails.payorId.$touch && _ctx.v$.newVisitDetails.payorId.$touch(...args)))
                }, [
                  _hoisted_130,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payorList, (payor) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: payor.insuranceId
                    }, _toDisplayString(payor.name) + " (" + _toDisplayString(payor.typeName) + ") ", 9 /* TEXT, PROPS */, _hoisted_131))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vShow, !_ctx.isPaymentSourceLoading],
                  [_vModelSelect, _ctx.newVisitDetails.payorId]
                ]),
                (_ctx.v$.newVisitDetails.payorId.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_132, "Payment Source is required."))
                  : _createCommentVNode("v-if", true),
                _withDirectives(_createElementVNode("div", null, _hoisted_134, 512 /* NEED_PATCH */), [
                  [_vShow, _ctx.isPaymentSourceLoading]
                ])
              ]),
              _createElementVNode("div", _hoisted_135, [
                _hoisted_136,
                _hoisted_137,
                (!!_ctx.taskDropdownSelectOptions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                      _createVNode(_component_GroupDropdownSelect, {
                        "drop-down-options": _ctx.taskDropdownSelectOptions,
                        "label-text": "Task",
                        "selected-value": _ctx.newVisitDetails.customNoteId,
                        "selected-text": _ctx.newVisitDetails.taskName,
                        "selected-id": _ctx.newVisitDetails.disciplineTask,
                        onUpdateSelectFields: _ctx.updateSelectFields,
                        class: _normalizeClass(` ${!_ctx.v$.newVisitDetails.disciplineTask.$error ? '' : 'field-invalid mt-0'}`),
                        onBlur: _ctx.v$.newVisitDetails.disciplineTask.$touch
                      }, null, 8 /* PROPS */, ["drop-down-options", "selected-value", "selected-text", "selected-id", "onUpdateSelectFields", "class", "onBlur"]),
                      (_ctx.v$.newVisitDetails.disciplineTask.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_139, "Task is required."))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _hoisted_140,
              (_ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.None && !_ctx.scheduleWithoutTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                    _hoisted_142,
                    _withDirectives(_createElementVNode("i", _hoisted_143, null, 512 /* NEED_PATCH */), [
                      [_directive_tooltip, { title: _ctx.careGivTooltip }]
                    ]),
                    _createVNode(_component_MultiSelectDropdown, {
                      "has-actions": true,
                      class: "text-center",
                      "selected-items": _ctx.selectedConflictTypes,
                      onSelectedItemsUpdated: _ctx.selectedItemsUpdated,
                      options: _ctx.conflictTypes,
                      "show-icons": true,
                      disabled: _ctx.isEmployeeListLoading || !_ctx.canShowPremium,
                      "find-a-match": true
                    }, null, 8 /* PROPS */, ["selected-items", "onSelectedItemsUpdated", "options", "disabled"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: _normalizeClass(`form-group col-10 col-md-6 col-lg-3 ${
                            _ctx.newVisitDetails.recurrence.type == _ctx.recurrenceTypeEnum.None ? 'pt-1' : ''
                        }`)
              }, [
                _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.newVisitDetails.recurrence.type != _ctx.recurrenceTypeEnum.None ? "Caregiver/Employee" : ""), 1 /* TEXT */),
                (!_ctx.isEmployeeListLoading)
                  ? (_openBlock(), _createBlock(_component_GroupDropdownSelect, {
                      key: 0,
                      "drop-down-options": _ctx.employeeDropdownSelectOptions,
                      dropdownList: _ctx.employeeDropdownSelectList,
                      isList: _ctx.scheduleWithoutTime || _ctx.newVisitDetails.recurrence.type != 0,
                      "label-text": "Employee",
                      "selected-value": _ctx.newVisitDetails.userId,
                      "selected-text": _ctx.displayName,
                      onUpdateSelectFields: _ctx.updateSelectEmpFields,
                      "show-icons": true,
                      disabled: _ctx.employeeIsPreSelected
                    }, null, 8 /* PROPS */, ["drop-down-options", "dropdownList", "isList", "selected-value", "selected-text", "onUpdateSelectFields", "disabled"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_145, _hoisted_147))
              ], 2 /* CLASS */),
              (!_ctx.employeeIsPreSelected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                    (_ctx.canShowPremium)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                          _createElementVNode("div", {
                            class: "find-ai-button-section",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openFindAMatch($event)))
                          }, _hoisted_151)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_152, [
                          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_153, _hoisted_156)), [
                            [_directive_tooltip, {
                                    title: `Contact Axxess to unlock this <br /> premium Axxess intelligence feature.`,
                                    placement: 'top',
                                    className: 'lock-premium'
                                }]
                          ])
                        ]))
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_157,
              _hoisted_158,
              _hoisted_159,
              (_ctx.showPostToAxxessCare)
                ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "billable",
                        class: "form-check-input",
                        checked: _ctx.newVisitDetails.postToAxxessCare,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.newVisitDetails.postToAxxessCare) = $event))
                      }, null, 8 /* PROPS */, _hoisted_161), [
                        [_vModelCheckbox, _ctx.newVisitDetails.postToAxxessCare]
                      ]),
                      _hoisted_162
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.newVisitDetails.postToAxxessCare)
                ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                    _hoisted_164,
                    _withDirectives(_createElementVNode("select", {
                      id: "task-name",
                      class: _normalizeClass(`form-select ${
                                !_ctx.v$.newVisitDetails.discipline.$error && _ctx.newVisitDetails.postToAxxessCare
                                    ? ''
                                    : 'field-invalid mt-0'
                            }`),
                      onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onTaskTypeChange(_ctx.newVisitDetails.discipline))),
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.newVisitDetails.discipline) = $event))
                    }, [
                      _hoisted_165,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialties, (task, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: task.id,
                          key: index
                        }, _toDisplayString(task.name), 9 /* TEXT, PROPS */, _hoisted_166))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 34 /* CLASS, HYDRATE_EVENTS */), [
                      [_vModelSelect, _ctx.newVisitDetails.discipline]
                    ]),
                    (_ctx.v$.newVisitDetails.discipline?.$error && _ctx.newVisitDetails.postToAxxessCare)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_167, "Task Type is required."))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              _hoisted_168,
              _createElementVNode("div", _hoisted_169, [
                _hoisted_170,
                _createVNode(_component_CommentInput, {
                  id: "comments",
                  "input-name": "nonadmit-comments",
                  "show-template-typeahead": false,
                  "comment-required": false,
                  result: _ctx.newVisitDetails.comments,
                  "max-length": 1000,
                  onResultUpdated: _ctx.resultUpdated
                }, null, 8 /* PROPS */, ["result", "onResultUpdated"])
              ])
            ])
          ])),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("span", _hoisted_172, _hoisted_174))
              : (_openBlock(), _createElementBlock("span", _hoisted_175, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndExit)))
                  }, "Save and Exit"),
                  _createVNode(_component_SaveNotifyUser, {
                    "agency-id": _ctx.newVisitDetails.agencyId,
                    "button-name": "Save and Notify Employee",
                    onHandleSaveVisit: _cache[21] || (_cache[21] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndNotifyEmployee)))
                  }, null, 8 /* PROPS */, ["agency-id"]),
                  _createElementVNode("button", {
                    class: "btn btn-primary ms-2",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.scheduleVisit(_ctx.SaveEnum.SaveAndAddAnother)))
                  }, " Save and Add Another "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ms-2 btn btn-md btn-outline-secondary",
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.cancel()))
                  }, " Cancel ")
                ]))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}